import { useCallback, useMemo, useReducer } from 'react';
import { ModalContext, ModalState, defaultModalState } from '../../context/ModalContext';
import { ModalHost } from './ModalHost';

type ModalAction =
  | { type: 'OPEN'; modalType: string; props: Record<string, unknown> }
  | { type: 'CLOSE' };

function modalReducer(_state: ModalState, action: ModalAction): ModalState {
  switch (action.type) {
    case 'OPEN':
      return { isOpen: true, type: action.modalType, props: action.props };
    case 'CLOSE':
      return { isOpen: false, type: null, props: {} };
  }
}

interface ModalProviderProps {
  children: React.ReactNode;
}

export const ModalProvider = ({ children }: ModalProviderProps) => {
  const [state, dispatch] = useReducer(modalReducer, defaultModalState);

  const openModal = useCallback((type: string, props: Record<string, unknown> = {}) => {
    dispatch({ type: 'OPEN', modalType: type, props });
  }, []);

  const closeModal = useCallback(() => {
    dispatch({ type: 'CLOSE' });
  }, []);

  const value = useMemo(() => ({ state, openModal, closeModal }), [state, openModal, closeModal]);

  return (
    <ModalContext.Provider value={value}>
      {children}
      <ModalHost />
    </ModalContext.Provider>
  );
};
